<div class="card modern-card d-flex flex-column">
  <div class="card-header border-0 bg-transparent pt-3 px-4">
    <div class="d-flex justify-content-between align-items-center">
      <div class="header-content">
        <h1 class="modern-header">FFL Lookup</h1>
      </div>

      <div class="header-actions header">
        <button
          type="button"
          class="close-btn"
          (click)="openHome()"
          title="Close"
          >
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
    </div>

    <div
      class="action-bar mt-3 d-flex justify-content-between align-items-center bg-dark-subtle rounded-3"
      >
      <div class="left-actions" style="color: #BDBDBD">
        @if (lastSyncDate) {
          <span class="text-light small">
            <i class="fa-solid fa-clock-rotate-left me-1"></i>
            Last Synced: {{ lastSyncDate | date: "MM/dd/yyyy h:mm a" }}
          </span>
        }
      </div>

      <div class="right-actions d-flex gap-2">
        <!-- not needed right now but leaving for future use -->
        <!-- <button
          class="btn modern-btn btn-secondary btn-sm"
          (click)="saveCurrentTablePreferencesClick()"
          >
          <i class="fa-solid fa-floppy-disk me-2"></i>Save Table Settings
        </button> -->
        <button
          class="btn modern-btn blue-btn btn-sm"
          (click)="refreshTableDataClick()"
          >
          <i class="fa-solid fa-rotate me-2 header"></i>Refresh Table
        </button>
      </div>
    </div>
  </div>

  <div class="card-body p-0 d-flex flex-column flex-grow-1">
    <ag-grid-angular
      id="ffl_search_list"
      class="modern-grid flex-grow-1"
      style="width: 100%; height: 100%"
      
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [gridOptions]="gridOptions"
      [rowData]="rowData"
      (gridReady)="onGridReady($event)"
      [overlayLoadingTemplate]="overlayLoadingTemplate"
      [animateRows]="true"
      [rowSelection]="rowSelection"
      [components]="components"
      [enableBrowserTooltips]="true"
      [pagination]="true"
      [paginationPageSize]="100"
      [preventDefaultOnContextMenu]="true"
      (cellContextMenu)="onCellContextMenu($event)"
      (filterChanged)="storeCurrentSessionFilters()"
      (columnPinned)="storeCurrentSessionColumnConfig()"
      (columnResized)="storeCurrentSessionColumnConfig()"
      (columnMoved)="storeCurrentSessionColumnConfig()"
      (sortChanged)="storeCurrentSessionColumnConfig()"
    ></ag-grid-angular>
  </div>
</div>

<!-- Added for the right click "Copy" function -->
@if ((menuState$ | async)?.showMenu) {
  <div
    class="custom-context-menu"
    [style.top.px]="(menuState$ | async)?.menuTop"
    [style.left.px]="(menuState$ | async)?.menuLeft"
    (click)="copyCellValue()"
    (mouseenter)="onMenuMouseEnter()"
    (mouseleave)="onMenuMouseLeave()"
    >
    <i class="fa-solid fa-copy me-2"></i> Copy
  </div>
}
